import { useState } from 'react';
import { useNotify } from '../../../context/NotifyContext';
import { parseError } from '../../../utils/errors';

export function useTxRunner() {
  const { notify } = useNotify();
  const [busy, setBusy] = useState(null);

  const run = async (label, fn, successMsg) => {
    try {
      setBusy(label);
      const tx = await fn();
      if (tx && tx.wait) await tx.wait();
      notify('success', successMsg || `${label} confirmed`);
      setBusy(null);
      return true;
    } catch (err) {
      setBusy(null);
      notify('error', parseError(err));
      return false;
    }
  };

  return { busy, run };
}
